module.exports = Em.Handlebars.compile("{{#each app in apps}}\n	{{app-store-item organization=organization app=app}}\n{{/each}}\n");